import {BaseContainerModel} from '../base-container.model';
import {app_perm_set_hdr_RowClass, app_perm_set_line_RowInterface} from '../../dbschema';

export class PermissionSetContainerModel extends BaseContainerModel {
  app_perm_set_hdr: app_perm_set_hdr_RowClass = new app_perm_set_hdr_RowClass();
  app_perm_set_lines: Array<app_perm_set_line_RowInterface> = [];
}
